<template>
	<div id="usuario-cuenta" class="d-flex account-page">
		<div class="container">

			<div class="row">
				<div class="col-xl-10 offset-xl-1 main-box">

					<div class="row">

						<!-- <div class="col-12 px-2">
							<h1 class="mb-3 page-title">{{ title }}</h1>
						</div> -->

						<div class="col-lg-4 px-2 col-menu">
							<div class="white-box card-like primary-dark-border">

								<div class="box-profile">
									<div class="d-block mt-4">
										<span class="fa-stack fa-4x user-icon">
											<i class="fas fa-circle fa-stack-2x"></i>
											<i class="fas fas fa-user fa-stack-1x fa-inverse"></i>
										</span>
										<template v-if="isLogged">
											<h5 class="txt-username">
												Bienvenido <br> {{ getUser.nombre }}
												{{ getUser.apellidos }}
											</h5>
											<b-button @click="logout()" variant="link" size="sm" block>
												Cerrar sesión
											</b-button>
											<div class="spei-details">
												<h6>
													CLABE: {{ getUser.stripe_spei_clabe }}
												</h6>
												<div class="block">
													<small>
														Cuentahabiente:
														{{ getUser.stripe_spei_account_holder_name }}
													</small>
												</div>
												<div class="block">
													<small>
														Banco:
														{{ getUser.stripe_spei_bank_name }}
													</small>
												</div>
												<hr>
												<div class="block walletCash">
													<span v-if="loadingWallet" class="spinner-border spinner-border-sm"
														role="status" aria-hidden="true"></span>
													<template v-else>
														<div class="block">
															<small>Saldo en Wallet:</small> <br>
															<span class="green" v-if="walletCash">{{ walletCash / 100 | currency }} MXN</span>
															<span v-else>{{ 0 | currency }} MXN</span>
															<span class="info imoon-info-circle" id="saldo-info"
																:class="{ active: toggleSaldoInfo }"
																@click="toggleSaldoInfo = !toggleSaldoInfo"></span>
															<b-tooltip :show.sync="toggleSaldoInfo" target="saldo-info"
																placement="right" custom-class="saldo-info">
																Este es tu saldo a favor para pagar facturas próximas
															</b-tooltip>
														</div>
														<!-- {{ toggleSaldoInfo }} -->
													</template>
												</div>
											</div>
										</template>
										<h5 class="txt-username" v-else>
											Crea tu cuenta
										</h5>
									</div>
								</div>

								<!-- <div class="box-menu">
									<p class="item">
										<router-link class="btn-menu" to="/usuario/mis-datos">
											<i class="far fa-edit"></i>
											Mis datos
										</router-link>
									</p>
									<p class="item">
										<router-link class="btn-menu" to="/usuario/contrasena"><i
												class="fas fa-lock"></i>
											Mi contraseña
										</router-link>
									</p>
									<p class="item">
										<router-link class="btn-menu" to="/usuario/numeros"><i
												class="fas fa-dot-circle"></i>
											Mis numeros BlackFon®
										</router-link>
									</p>
									<p class="item">
										<router-link class="btn-menu" to="/usuario/metodos-pago"><i
												class="fas fa-dot-circle"></i>
											Mis métodos de pago
										</router-link>
									</p>
									<p class="item">
										<router-link class="btn-menu" to="/usuario/ordenes-de-pago">
											<i class="fas fa-dot-circle"></i> Mis ordenes de pago
										</router-link>
									</p>
									<p class="item">
										<router-link class="btn-menu" to="/usuario/mis-pedidos"><i
												class="fa fa-file"></i> Mis pedidos</router-link>
									</p>
									<p class="item">
										<a class="btn-menu" v-on:click="logout()" style="cursor: pointer;">
											<i class="fas fa-sign-out-alt"></i> Cerrar sesión</a>
									</p>

								</div> -->

							</div>
						</div>

						<div class="col-lg px-2 col-acc-page">
							<ui-tabs class="mb-3" :options="optionTabs" size="sm" disable-button-mode></ui-tabs>
							<router-view class="white-box" />
						</div>

					</div>

				</div>
			</div>

		</div>
	</div>
</template>

<script>
import UiTabs from '../daniel/ui-tabs'
import { mapActions, mapGetters } from 'vuex';
const activeTab = [
	{ label: 'Mis líneas', icon: 'fas fa-dot-circle', route: '/usuario/numeros' },
	{ label: 'Mis suscripciones', icon: 'fas fa-dot-circle', route: '/usuario/suscripciones' },
	{ label: 'Mi cuenta', icon: 'far fa-edit', route: '/usuario/mis-datos' },
	// { label: 'Cambiar contraseña', icon: 'fas fa-lock', route: '/usuario/contrasena' },
	// { label: 'Métodos de pago', icon: 'fas fa-dot-circle', route: '/usuario/metodos-pago' },
	{ label: 'Historial de pago', icon: 'fas fa-dot-circle', route: '/usuario/ordenes-de-pago' },
];
export default {
	components: { UiTabs },
	computed: {
		...mapGetters(['isLogged', 'getUser'])
	},

	props: {
		optionTabs: {
			type: Array,
			default: () => activeTab
		}
	},

	data() {
		return {
			title: 'Mi cuenta',
			loadingWallet: false,
			walletCash: 0,
			toggleSaldoInfo: false,
		}
	},

	methods: {
		...mapActions(['authAsk4LogOut']),
		async updateWallet() {
			this.loadingWallet = true;
			try {
				let response = await axios.get('account/getwallet');
				if (response.status)
					this.walletCash = response.data.available.mxn;
				else
					this.$toast.error('Error al obtener la billetera.');
			} catch (error) {
				this.$toast.error('Error al actualizar la billetera.');
				this.walletCash = 0;
			} finally {
				this.loadingWallet = false;
			}
		},
		getUrlName() {
			var urlName = this.$route.path;
			// UPDATE GENERAL
			if (urlName == '/usuario') { this.title = 'Mi Cuenta' }
			if (urlName == '/usuario/mis-datos') { this.title = 'Mis datos' }
			if (urlName == '/usuario/contrasena') { this.title = 'Cambiar contraseña' }
			if (urlName == '/usuario/mis-pedidos') { this.title = 'Mis pedidos' }
		},

		async logout() {
			let response = await this.authAsk4LogOut()
			if (response)
				this.$router.replace('/')
		},
	},

	beforeMount() {
		this.getUrlName();
		this.updateWallet();
	},

	mounted() {
		if (this.$root.logged == false) {
			this.$router.push("/");
		}
	},

	watch: {
		$route(to, from) {
			this.getUrlName();
		},
	}
}
</script>

<style lang="scss">
@import '@/sass/utils/variables.scss';

.saldo-info {

	&.bs-tooltip-bottom .arrow::before {
		border-bottom-color: #{$accent} !important;
	}

	&.bs-tooltip-right .arrow::before {
		border-right-color: #{$accent} !important;
	}

	.tooltip-inner {
		background-color: #{$accent};
	}
}

#usuario-cuenta {
	.box-menu {
		display: none;
	}

	.spei-details {
		padding: 1em;
		background-color: black;
		margin: 0.5em;
		border: var(--primary-dark-border);
	}

	.walletCash {
		font-weight: bold;
		color: white;

		span {

			// color: var(--primary);
			&.green {
				color: rgb(89, 173, 89);
			}

			&.info {
				color: rgb(160, 160, 160);
				cursor: pointer;
			}

			&.active {
				color: var(--primary);
			}

			font-size: 1.25em;
		}
	}
}
</style>